// This import loads the firebase namespace along with all its type information.
import ContentCreator from './content-creator-model'

export async function load_contentCreators(): Promise<ContentCreator[]> {
  throw 'Not implemented'
}

export async function delete_contentCreator(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_contentCreator(): Promise<ContentCreator> {
  throw 'Not implemented'
}
